import OrderPage from "views/customer/order/page/OrderPage";

export default function OrderIndex() {
  return <OrderPage />;
}
